import { useQuery, useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../useAuth";
import { getPath, endpoints } from "./apiUtils";

export const useUsageReport = () => {
  const { getAccessToken } = useContext(AuthContext);
  const path = getPath({
    endpoint: endpoints.admin,
    path: ["usagereport"],
  });

  return useQuery(["admin", "usagereport"], async () =>
    axios
      .get(path, { headers: { Authorization: await getAccessToken() } })
      .then((r) => r.data)
  );
};

export const useAdminCaregiver = (params) => {
  const { getAccessToken } = useContext(AuthContext);
  const path = getPath({
    endpoint: endpoints.admin,
    path: ["caregivers"],
    queryParameters: params,
  });

  let searchParams = [];
  if (params) {
    Object.keys(params).forEach((p) => {
      // searchParams.push(p);
      searchParams.push({ p: params[p] });
    });
  }

  return useQuery(["admin", "caregivers", searchParams], async () =>
    axios
      .get(path, { headers: { Authorization: await getAccessToken() } })
      .then((r) => r.data)
  );
};

export const useCaregiverAdminUpdate = (userId) => {
  const { getAccessToken } = useContext(AuthContext);

  const path = getPath({
    endpoint: endpoints.admin,
    path: ["caregivers", userId],
  });

  return useMutation(async (data) => {
    const resp = await axios.put(path, data, {
      headers: { Authorization: await getAccessToken() },
    });
    return resp?.data;
  });
};

export const useCaregiverApplication = (userId) => {
  const { getAccessToken } = useContext(AuthContext);
  const path = getPath({
    endpoint: endpoints.admin,
    path: ["caregivers", userId, "application"],
  });

  return useQuery(["caregivers", userId, "application"], async () =>
    axios
      .get(path, { headers: { Authorization: await getAccessToken() } })
      .then((r) => r.data)
  );
};

export const useCreateBackgroundCheckr = () => {
  const { getAccessToken } = useContext(AuthContext);
  const path = getPath({
    endpoint: endpoints.checkr,
  });
  return useMutation(async (data) =>
    axios
      .post(path, data, { headers: { Authorization: await getAccessToken() } })
      .then((r) => r.data)
  );
};
